import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
};

const browseProducts = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.PRODUCTS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actions.PRODUCTS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case actions.PRODUCTS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default browseProducts;
